import React, { useEffect, useState } from 'react'
import { MODE, filterIsDeleted } from '../constant'
import useDropdown from '../context/useDropdown'
import { Col, Row, Typography, message } from 'antd'
import BtnEditUC from '../../../components/Form/BtnEditUC'
import BtnDeleteUC from '../../../components/Form/BtnDeleteUC'
import SelectUC from '../../../components/Form/SelectUC'
import ButtonUC from '../../../components/buttonUC'
import HeaderBarAdd from '../headerBarAdd'
import AutoCompleteUC from '../../../components/Form/AutoCompleteUC'

const CapabilityLang = ({ props }) => {
    const {
        form,
        rcAppProfileCapabilityLang,
        setRcAppProfileCapabilityLang,
        rcDeletedData,
        setRcDeletedData,
        isReadOnly
    } = props

    const { Text } = Typography
    const [mode, setMode] = useState(MODE.VIEW) //view, edit
    const { ddlCapabilityLang, ddlCapabilityLevel, getDDLLabel, getDDLId } = useDropdown()
    const [isReq, setReq] = useState(false)

    useEffect(() => {
        setReq(mode === MODE.EDIT)
    }, [mode])

    const handleAdd = () => {
        console.log('handleAdd')
        // new
        let newRow = {
            sort: 1,
            languageId: null,
            speakingId: null,
            listeningId: null,
            readingId: null,
        }

        if (rcAppProfileCapabilityLang && rcAppProfileCapabilityLang.length > 0) {
            const max = Math.max(...rcAppProfileCapabilityLang.map(o => o.sort))
            newRow = {
                ...newRow,
                sort: max + 1,
            }
        }

        setForm(newRow)
        setMode(MODE.EDIT)
    }

    const setForm = (record) => {
        form.setFieldsValue({
            capLang_sort: record.sort,
            capLang_languageId: record.id ? record.languageName : record.languageId,
            capLang_speakingId: record.speakingId,
            capLang_listeningId: record.listeningId,
            capLang_readingId: record.readingId,
        })
    }

    const handleEdit = (record) => {
        console.log('handleEdit', record)
        if (record) {
            setForm(record)
            setMode(MODE.EDIT)
        }
    }

    const handleDelete = (record) => {
        if (record.id) {
            // เก็บ Record ที่ลบ
            setRcDeletedData([...rcDeletedData, { id: record.id, tableName: 'appProfileCapabilityLang' }])
        }
        setRcAppProfileCapabilityLang(rcAppProfileCapabilityLang.filter(r => r.sort !== record.sort))
    }

    const handleCancel = () => {
        setMode(MODE.VIEW)
    }

    const handleSubmit = () => {
        console.log('handleSubmit')
        const dataPreSubmit = {
            sort: form.getFieldValue('capLang_sort'),
            languageId: form.getFieldValue('capLang_languageId'),
            speakingId: form.getFieldValue('capLang_speakingId'),
            listeningId: form.getFieldValue('capLang_listeningId'),
            readingId: form.getFieldValue('capLang_readingId'),
        }

        const dataColValidate = [
            { caption: "กรุณาเลือกภาษา", columnName: "capLang_languageId" },
            { caption: "กรุณาเลือกการพูด", columnName: "capLang_speakingId" },
            { caption: "กรุณาเลือกการฟัง", columnName: "capLang_listeningId" },
            { caption: "กรุณาเลือกการอ่าน", columnName: "capLang_readingId" }
        ]

        let isValidate = false
        dataColValidate.forEach(el => {
            const _isValidate = checvalidateDraft(el)
            isValidate = isValidate ? isValidate : (_isValidate ?? false)
        })

        if (isValidate) {
            message.warning('กรุณากรอกข้อมูลความสามารถทางภาษา');
            return false
        } else {
            const row = rcAppProfileCapabilityLang.filter(item => item.sort === dataPreSubmit.sort)
            if (row && row.length > 0) {
                setRcAppProfileCapabilityLang(rcAppProfileCapabilityLang.map((obj) => obj.sort === dataPreSubmit.sort ? dataPreSubmit : obj))
            } else {
                setRcAppProfileCapabilityLang([...rcAppProfileCapabilityLang, dataPreSubmit])
            }

            setMode(MODE.VIEW)
        }
    }

    const checvalidateDraft = (e) => {
        const _data = form.getFieldValue([e.columnName])
        if (!_data || _data === '') {
            form.setFields([
                {
                    name: [e.columnName],
                    errors: [e.caption],
                },
            ]);
            return true
        }
        return false
    }

    const setFormEdit = (e) => {
        let capLang_language = null, capLang_speaking = null, capLang_listening = null, capLang_reading = null
        if (ddlCapabilityLang.filter(filterIsDeleted)?.length > 0) {
            capLang_language = ddlCapabilityLang.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('capLang_languageId'))
        }
        if (ddlCapabilityLevel.filter(filterIsDeleted)?.length > 0) {
            capLang_speaking = ddlCapabilityLevel.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('capLang_speakingId'))
        }
        if (ddlCapabilityLevel.filter(filterIsDeleted)?.length > 0) {
            capLang_listening = ddlCapabilityLevel.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('capLang_listeningId'))
        }
        if (ddlCapabilityLevel.filter(filterIsDeleted)?.length > 0) {
            capLang_reading = ddlCapabilityLevel.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('capLang_readingId'))
        }
        form.setFieldsValue({
            capLang_languageId: capLang_language ? capLang_language.value : form.getFieldValue('capLang_languageId'),
            capLang_speakingId: capLang_speaking ? capLang_speaking.value : null,
            capLang_listeningId: capLang_listening ? capLang_listening.value : null,
            capLang_readingId: capLang_reading ? capLang_reading.value : null,
        })
    }

    const FormView = ({ data }) => {
        const _lang = data.id ? (ddlCapabilityLang?.find(e => e.id === data.languageId)?.value ?? data.languageName) : data.languageId
        const _speaking = getDDLLabel(ddlCapabilityLevel, data.speakingId)
        const _listening = getDDLLabel(ddlCapabilityLevel, data.listeningId)
        const _reading = getDDLLabel(ddlCapabilityLevel, data.readingId)
        return (
            <>
                <Row className="py-2 p-3 justify-between">
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text className='text-lang color-secondary1'>{_lang}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text className='text-speaking mr-1'>การพูด:</Text>
                        <Text className='text-speaking color-gray6'>{_speaking}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text className='text-listening mr-1'>การฟัง:</Text>
                        <Text className='text-listening color-gray6'>{_listening}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2 flex items-center'>
                        <Text className='text-reading mr-1'>การอ่าน:</Text>
                        <Text className='text-reading color-gray6'>{_reading}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2'>
                        <div className="flex justify-end">
                            <BtnEditUC disabled={data.isCanNotEdit === true || isReadOnly} handleEdit={() => handleEdit(data)} />
                            <BtnDeleteUC disabled={data.isCanNotDelete === true || isReadOnly} handleDelete={() => handleDelete(data)} />
                        </div>
                    </Col>
                </Row>
            </>
        )
    }


    const FormEdit = () => {
        setFormEdit()
        return (
            <>
                <Row className="py-2">
                    <Col span={0} className={'hidden'}>
                        <Text name={'capLang_sort'}></Text>
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <AutoCompleteUC
                            maxLength={50}
                            required={isReq}
                            label='ภาษา'
                            name={'capLang_languageId'}
                            options={ddlCapabilityLang.filter(filterIsDeleted)} />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col xs={24} md={8} className='px-2'>
                        <SelectUC required={isReq} label='การพูด' name={'capLang_speakingId'} optionValues={ddlCapabilityLevel.filter(filterIsDeleted)} />
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <SelectUC required={isReq} label='การฟัง' name={'capLang_listeningId'} optionValues={ddlCapabilityLevel.filter(filterIsDeleted)} />
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <SelectUC required={isReq} label='การอ่าน' name={'capLang_readingId'} optionValues={ddlCapabilityLevel.filter(filterIsDeleted)} />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className='px-2 flex justify-end'>
                        <ButtonUC className='btn-clear mr-3' onClick={() => handleCancel()}>ยกเลิก</ButtonUC>
                        <ButtonUC className='btn-custom ml-3' onClick={() => handleSubmit()}>บันทึก</ButtonUC>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <div className='div-cap-lang w-full'>
            <HeaderBarAdd title={'ความสามารถทางภาษา'} handleAdd={handleAdd} disabled={mode === 'edit' || isReadOnly} />
            {mode === 'view' && rcAppProfileCapabilityLang && rcAppProfileCapabilityLang.length > 0 ?
                <>
                    {rcAppProfileCapabilityLang.map((item, index) => {
                        return (
                            <FormView key={index} data={item} />
                        )
                    })}
                </>
                : <>{mode === 'edit' && <FormEdit />}</>}
        </div>
    )
}

export default CapabilityLang